(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeEgaleXLightbox = (root) => {
    if (root.dataset.egaleXLightboxReady === 'true') return;

    const sectionContainer = root.closest('.shopify-section') || root.parentElement;
    const dialog = sectionContainer?.querySelector('[data-egale-x-dialog]');
    const dialogImage = dialog?.querySelector('[data-egale-x-image]');
    const counter = dialog?.querySelector('[data-egale-x-count]');
    const closeButton = dialog?.querySelector('[data-egale-x-close]');
    const previousButton = dialog?.querySelector('[data-egale-x-previous]');
    const nextButton = dialog?.querySelector('[data-egale-x-next]');
    const images = [...root.querySelectorAll('img')];

    if (!dialog || !dialogImage || images.length === 0) return;

    let activeIndex = 0;
    let activeTrigger = null;

    const updateImage = () => {
      const sourceImage = images[activeIndex];
      dialogImage.src = sourceImage.currentSrc || sourceImage.src;
      dialogImage.alt = sourceImage.alt || '';
      counter.textContent = `${activeIndex + 1} / ${images.length}`;
    };

    const openDialog = (index, trigger) => {
      activeIndex = index;
      activeTrigger = trigger;
      updateImage();
      dialog.showModal();
      closeButton?.focus();
    };

    const showPrevious = () => {
      activeIndex = (activeIndex - 1 + images.length) % images.length;
      updateImage();
    };

    const showNext = () => {
      activeIndex = (activeIndex + 1) % images.length;
      updateImage();
    };

    images.forEach((image, index) => {
      image.tabIndex = 0;
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', `${dialog.dataset.openLabel} ${index + 1}`);

      image.addEventListener('click', (event) => {
        event.preventDefault();
        openDialog(index, image);
      });

      image.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openDialog(index, image);
        }
      });
    });

    closeButton?.addEventListener('click', () => dialog.close());
    previousButton?.addEventListener('click', showPrevious);
    nextButton?.addEventListener('click', showNext);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showPrevious();
      if (event.key === 'ArrowRight') showNext();
    });

    dialog.addEventListener('close', () => {
      activeTrigger?.focus();
    });

    root.dataset.egaleXLightboxReady = 'true';
  };

  const initializeAllEgaleXLightboxes = (scope = document) => {
    scope.querySelectorAll('[data-egale-x-lightbox]').forEach(initializeEgaleXLightbox);
  };

  initializeAllEgaleXLightboxes();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllEgaleXLightboxes(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
